import storage from '~js/storage';

const vazio = {
  projetoConsultar: false,
  projetoAlterar: false,
  projetoApagar: false,
  bancoConsultar: false,
  bancoAlterar: false,
  bancoApagar: false,
  configuracaoProjeto: false,
  configuracaoBanco: false,
  tesourariaConsultar: false,
  tesourariaAlterar: false,
};

function permissoes() {
  const usuario = storage.usuario();
  return (usuario && usuario.permissoesConciliacao) || vazio;
}

export default {
  todas: permissoes,
  consultar(modo) {
    const p = permissoes();
    if (modo === 'tesouraria') return !!p.tesourariaConsultar;
    return modo === 'banco' ? p.bancoConsultar : p.projetoConsultar;
  },
  alterar(modo) {
    const p = permissoes();
    if (modo === 'tesouraria') return !!(p.tesourariaConsultar && p.tesourariaAlterar);
    return modo === 'banco' ? p.bancoAlterar : p.projetoAlterar;
  },
  apagar(modo) {
    const p = permissoes();
    return modo === 'banco' ? p.bancoApagar : p.projetoApagar;
  },
  configurar(modo) {
    const p = permissoes();
    return modo === 'banco' ? p.configuracaoBanco : p.configuracaoProjeto;
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/js/permissoes-conciliacao.js